import { memo } from 'react';
import { ENV_CONFIG } from 'config/environment';
import { DashboardScreen, trackEvent } from 'helpers/mixpanelEvents';

const SCREEN: DashboardScreen = 'recipients_dashboard';

interface RecipientsFAQProps {
  className: string;
}

export const RecipientsFAQ = memo(({ className }: RecipientsFAQProps) => {
  return (
    <div className={className}>
      <div className="card">
        <div className="card-body recipients-card-content">
          <span className="h4-text">Recipient Help Center</span>

          <span className="body-text">Have questions? Visit our Recipient Help Center:</span>

          <div className="col-md-8 padding0">
            <button
              type="button"
              className="btn-inkBlue btn btn-secondary"
              onClick={() => {
                trackEvent('Help Center Clicked', { screen: SCREEN });
                const win = window.open(
                  `${ENV_CONFIG().RECIPIENT_HELP_CENTER_URL}`,
                  '_blank',
                  'noopener,noreferrer'
                );
                if (win) win.opener = null;
              }}
            >
              <span className="body-small-text text-white">Oath Help Center</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
});

RecipientsFAQ.displayName = 'RecipientsFAQ';

export default RecipientsFAQ;
